export default __webpack_public_path__ + "static/media/complete_repair.094df3f1.gif";